import React, { useEffect, useState } from 'react';
import './DonateButton.css';

// Hosted PayPal donate button — keeps copy in English on every locale (per spec).
const DONATE_URL = 'https://www.paypal.com/donate/?hosted_button_id=LPC97GTZDJJSU';
const SEEN_KEY = 'donate_seen';

const DonateButton = () => {
  // Pulse the heart for ~2s ONLY on a visitor's very first arrival (localStorage flag).
  const [pulseHeart, setPulseHeart] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(SEEN_KEY)) {
        setPulseHeart(true);
        localStorage.setItem(SEEN_KEY, '1');
        const t = setTimeout(() => setPulseHeart(false), 2200);
        return () => clearTimeout(t);
      }
    } catch (e) {
      /* localStorage blocked → silently skip pulse */
    }
  }, []);

  return (
    <div className="donate-block" data-testid="donate-block">
      <p className="donate-pitch">
        <strong>Fuel the music you love.</strong>
        <br />
        <span className="donate-pitch-sub">
          This radio runs on passion, not ads. Every dollar keeps the records spinning.
        </span>
      </p>
      <a
        href={DONATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="donate-button"
        data-testid="donate-button"
        aria-label="Support the radio via PayPal"
      >
        <span className={`donate-heart${pulseHeart ? ' pulse' : ''}`} aria-hidden="true">
          ♥
        </span>
        SUPPORT THE RADIO
      </a>
    </div>
  );
};

export default DonateButton;
